import { Injectable } from '@angular/core';
import { Point } from '../../remote-control-ng';

export interface Transformation {
    previousScale: number;
    nextScale: number;
    rotation: number;
}

export interface Rect {
    x: number;
    y: number;
    width: number;
    height: number;
}

@Injectable({
    providedIn: 'root'
})
export class NxtRemoteControlPositioningService {

    constructor() { }

    // Panning offset calculator:
    // adjusts the panning offset based on the scale change, canvas size and the current (already scaled) device dimensions.
    // updates the offset object and returns the boolean indicating if the offset has changed
    public scaleOffset = (scale: Transformation, canvas: HTMLCanvasElement, deviceScreen: Rect, offset: Point): boolean => {
        let change = false;
        if (scale.previousScale !== scale.nextScale && (offset.x !== 0 || offset.y !== 0)) {
            // if the device fits the canvas on both sides, it gets centered
            if (deviceScreen.width <= canvas.width && deviceScreen.height <= canvas.height) {
                offset.x = offset.y = 0;
                return true;
            }

            const prevDeviceWidth = deviceScreen.width / scale.nextScale * scale.previousScale;
            const prevDeviceHeight = deviceScreen.height / scale.nextScale * scale.previousScale;

            // absolute change proportion, we don't want the scale that just fits the canvas trigger the sign change
            let xoff = Math.floor(offset.x * Math.abs((deviceScreen.width - canvas.width) / (prevDeviceWidth - canvas.width)));
            let yoff = Math.floor(offset.y * Math.abs((deviceScreen.height - canvas.height) / (prevDeviceHeight - canvas.height)));
            
            console.warn("OFFSETS ARE:", offset.x, offset.y, xoff, yoff);
            if (offset.x !== 0) {
                xoff = offset.x - Math.sign(offset.x)*Math.abs((offset.x - xoff));
                offset.x = offset.x / xoff < 0 ? 0 : xoff; // do not allow sign change in offset
                change = true;
            }
            if (offset.y !== 0) {
                yoff = offset.y - Math.sign(offset.y)*Math.abs((offset.y - yoff));
                offset.y = offset.y / yoff < 0 ? 0 : yoff; // do not allow sign change in offset
                change = true;
            }
        }
        return change;
    };
}
